/*
  Launch pages: sticky cart bar with a free-shipping meter.
  Reads /cart.js on load and whenever the cart changes (theme:cart:added from
  mini_cart.js, launch:cart:changed from launch-cart.js). The "View cart"
  button carries [data-cart-drawer-toggle], so the theme opens its own drawer.
  The bar appears once the visitor scrolls past the reveal offset.
*/
(function () {
  if (window.__launchCartbarLoaded) return;
  window.__launchCartbarLoaded = true;

  function money(cents) {
    return window.LaunchCart ? window.LaunchCart.formatMoney(cents) : '$' + Math.round(cents / 100);
  }

  function fetchCart() {
    if (window.LaunchCart) return window.LaunchCart.getCart();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function init(section) {
    if (section._launchInit) return;
    section._launchInit = true;

    var threshold = Math.round(parseFloat(section.getAttribute('data-threshold') || '0') * 100);
    var tplAway = section.getAttribute('data-msg-away') || '';
    var tplDone = section.getAttribute('data-msg-done') || '';
    var tplEmpty = section.getAttribute('data-msg-empty') || '';
    var tplOne = section.getAttribute('data-item-one') || '||count|| item';
    var tplOther = section.getAttribute('data-item-other') || '||count|| items';
    var offset = parseInt(section.getAttribute('data-reveal-offset') || '600', 10);
    var bar = section.querySelector('.launch-cartbar');
    var msg = section.querySelector('[data-launch-bar-msg]');
    var fill = section.querySelector('[data-launch-bar-fill]');
    var track = section.querySelector('[data-launch-bar-track]');
    var summary = section.querySelector('[data-launch-bar-summary]');
    var count = 0;

    function render(cart) {
      var total = cart.total_price || 0;
      count = cart.item_count || 0;
      var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
      var text;
      if (threshold > 0 && total >= threshold) text = tplDone;
      else if (count === 0) text = tplEmpty.replace('||amount||', money(threshold));
      else text = tplAway.replace('||amount||', money(threshold - total));
      if (msg) msg.textContent = text;
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', String(pct));
      if (summary) summary.textContent = (count === 1 ? tplOne : tplOther).replace('||count||', String(count)) + ' · ' + money(total);
    }

    function refresh() { fetchCart().then(render).catch(function () {}); }

    function onScroll() {
      var show = window.scrollY > offset;
      if (show !== section.classList.contains('is-visible')) {
        section.classList.toggle('is-visible', show);
        if (bar) bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (bar) bar.querySelectorAll('a, button').forEach(function (el) {
          if (show) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
        });
      }
    }

    document.addEventListener('theme:cart:added', refresh);
    document.addEventListener('launch:cart:changed', refresh);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (section.hasAttribute('data-always-visible')) {
      offset = -1;
    }
    onScroll();
    refresh();
  }

  function initAll() { document.querySelectorAll('[data-launch-cartbar]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-launch-cartbar]');
    if (s) init(s);
  });
})();
